export default {
    name: 'mine/playbacks',
    path: 'playbacks',
    component: () => import('./Root.vue')
}